import { FC } from 'react';
import { Text } from '../../components/Text';
import { CircleCheckIcon } from '../../theme/Icons';

export type INotesListTaskCountProps = {
    taskCount: number;
};

export const NotesListTaskCount: FC<INotesListTaskCountProps> = ({ taskCount }) => {
    if (taskCount === 0) {
        return null;
    }

    const getTaskText = (count: number) => {
        return count === 1 ? 'task' : 'tasks';
    };

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
            <CircleCheckIcon color="medium" />
            <Text color="medium">
                <div style={{fontSize: 14}}>
                    {taskCount} {getTaskText(taskCount)}
                </div>
            </Text>
        </div>
    );
};
